import { useCallback } from "react";
import { useHistory } from "react-router";
import {
  NavigateFunction,
  NavigateOptions,
  useNavigate,
} from "react-router-dom-v5-compat";

const useAppNavigation = () => {
  const _navigate = useNavigate();
  const history = useHistory();

  const navigate: NavigateFunction = useCallback(
    (to, opts?) => {
      if (typeof to === "number") {
        _navigate(to);
      } else {
        _navigate(to, opts as NavigateOptions);
      }
    },
    [_navigate],
  );

  const goBack = useCallback(() => {
    if (history.length === 1) {
      _navigate("/catalog");
    } else {
      _navigate(-1);
    }
  }, [_navigate, history]);
  return { goBack, navigate };
};
export { useAppNavigation };
